import config from '../../../config'
import {
  createSearchBody,
  createSearchRequestBody,
} from './request-builder/payment-engine-search-request-builder'
import http from './http-util'
import { appendPageInfoQueryParams } from './api-util'

class PaymentEngineSearchApi {
  static search = (requestData, token) => {
    const queryParams = appendPageInfoQueryParams(requestData)
    const body = createSearchBody(requestData)

    return http.post(
      token,
      `${config.paymentEngineSearchServiceUrl}/payments/search${queryParams}`,
      JSON.stringify(body),
      config.requestTimeoutTransactions,
    )
  }

  static searchTransactions = (request, token) => {
    const queryParams = appendPageInfoQueryParams(request)
    const body = createSearchRequestBody(request)
    return http.post(
      token,
      `${config.paymentEngineSearchServiceUrl}/search/transactions/query${queryParams}`,
      JSON.stringify(body),
      config.requestTimeoutTransactions,
    )
  }
}

export default PaymentEngineSearchApi
